<fieldset>
  @if (label) {
    <label [raskRequired]="required">
      {{label}}
      @if (infoText) {
        <rask-info>{{infoText}}</rask-info>
      }
    </label>
  }
  <ng-select #instance
    id="{{aid}}"
    [addTag]="false"
    [closeOnSelect]="closeOnSelect"
    bindValue="{{bindValue}}"
    groupBy="{{groupBy}}"
    clearAllText="{{clearAllTooltipText}}"
    [disabled]="disabled"
    [hideSelected]="hideSelected"
    [minTermLength]="minTermLength"
    [loading]="loading"
    loadingText="{{loadingText}}"
    notFoundText="{{notFoundText}}"
    typeToSearchText="{{typeToSearchText}}"
    [typeahead]="typeaheadInput$"
    [items]="items | async"
    [multiple]="true"
    [searchFn]="searchFn"
    [(ngModel)]="selected"
    [ngModelOptions]="{standalone: true}"
    [appendTo]="portalToBody ? 'body' : '#' + targetId"
    (change)="onSelectionChange($event)"
    (open)="onOpen($event)"
    (close)="onClose($event)">
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of items; track item) {
        <div class="ng-value">
          <span class="ng-value-label">{{viewSelectedFormatter(item)}}</span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"><i class="fal fa-times"></i></span>
        </div>
      }
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index">
      <span [ngClass]="{'disabled': itemDisabled(item)}">{{viewFormatter(item)}}</span>
    </ng-template>
  </ng-select>

  @if (rule) {
    <rask-validation-message [hidden]="isPopupOpen" [rule]="rule"></rask-validation-message>
  }
</fieldset>
<div [id]="targetId"></div>
